import React from 'react';
import { Location } from 'history';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { useUser } from '../../context/userContext';

export interface LocationState {
  from: Location;
}

export default function PrivateRoute({ children, ...rest }: RouteProps): React.ReactElement {
  const { user } = useUser();

  return (
    <>
      {!user.isLoaded ? (
        <></>
      ) : (
        <Route
          {...rest}
          render={({ location }) =>
            user.user ? (
              children
            ) : (
              <Redirect
                to={{
                  pathname: '/login',
                  state: { from: location },
                }}
              />
            )
          }
        />
      )}
    </>
  );
}
